import '@/assets/css/attendanceCalendar.css';
import AttendanceCalendar from '../components/Calendar';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import ModalConfirmarAcao from '@/shared/components/modals/ModalProximaAcao';
import ModalHistorico from '../modals/ModalHistoricoAttendanceSheet';
import MyContext from '@/shared/contexts/AppContext';
import { AttendanceSheetDayEnum } from '../../enums/attendance-sheet-day.enum';
import { AttendanceSheetPdf } from '../components/AttendanceSheetPDF';
import { AttendanceSheetResponseDto, ReadHolidayResponseDto, AttendanceSheetDayDto } from '@/api.types';
import { AttendanceSheetStatusEnum, attendanceSheetStatusEnumInFull, } from '../../enums/attendance-sheet-status.enum';
import { AttendanceSheetStatusIconByStatus } from '../components/IconeStatus';
import { Button, Modal } from 'react-bootstrap';
import { CarregarPermissoes, ValidarPermissao } from '@/modules/system/auth/application/auth.service';
import { FaRegFilePdf } from 'react-icons/fa';
import { LOCALIZACAO_SISTEMA } from '@/shared/constants/strings';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { PermissionEnum } from '@/modules/system/papeis/enum/permission.enum';
import { RoleEnum } from '@/modules/system/papeis/enum/role.enum';
import { diasDaSemana, DataAmigavel } from '@/shared/utils/datas';
import { exportFromJsxToPdf } from '@/shared/utils/pdf';
import { readByIdAttendanceSheet, sendToSignatureAttendanceSheet } from '../../attendance-sheet.service';
import { readHoliday } from '@/modules/business/holidays/holiday.service';
import { toast, ToastContainer } from 'react-toastify';
import { useContext, useEffect, useState } from 'react';

export default function AttendanceSheetEditPage() {
  const context = useContext(MyContext);
  if (!context)
    throw new Error('Contexto deve ser usado dentro de um Provedor.');

  const params = useParams();
  const navigate = useNavigate();
  const folhaId = params.id;

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showModalHistorico, setShowModalHistorico] = useState(false);
  const [showModalJustificativa, setShowModalJustificativa] = useState(false);
  const [acaoDeConfirmar, setAcaoDeConfirmar] = useState(true);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [isExecuting, setExecuting] = useState<boolean>(false);

  const [textoBtnA, setTextoBotaoA] = useState<string | undefined>('');
  const [textoBtnB, setTextoBotaoB] = useState<string | undefined>('');
  const [tituloDaCaixaDeTexto, setTituloDaCaixaDeTexto] = useState<string>('');
  const [tituloBotaoPrincipal, settituloBotaoPrincipal] = useState<string>('');
  const [corpoDaCaixaDeTexto, setCorpoDaCaixaDeTexto] = useState<string>('');
  const [mesSelecionado, setMesSelecionado] = useState<string>('');

  const [folha, setFolha] = useState<AttendanceSheetResponseDto>();
  const [feriados, setFeriados] = useState<ReadHolidayResponseDto[]>([]);

  const permissoes = CarregarPermissoes();
  const permissoesElevadas = context.state.username
    ? (
      ValidarPermissao(permissoes, [{ role: RoleEnum.FOLHA, level: PermissionEnum.DELETE }])
      || ValidarPermissao(permissoes, [{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.DELETE }])
    )
    : false;

  async function printAttendanceSheet(folhaId: string) {
    try {
      const folha = await readByIdAttendanceSheet(folhaId);
      exportFromJsxToPdf(<AttendanceSheetPdf folha={folha} />);
    } catch (error) {
      toast.error(String(error));
    }
  }

  useEffect(() => {
    setLoaded(false);

    async function fetchData() {
      try {
        if (!folhaId) {
          navigate(Links.Home, { replace: true });
          return;
        }

        const folhaResult = await readByIdAttendanceSheet(folhaId);

        if (!folhaResult) {
          navigate(Links.Home, { replace: true });
          return;
        }

        setFolha(folhaResult);

        const idDefensoria = folhaResult?.estagio?.lotacao?.defensoria?.id;
        const idSetor = (folhaResult as any)?.estagio?.lotacao?.setor?.id;
        // Datas em YYYY-MM-DD no mês da folha (evita problemas de timezone)
        const fromDate = `${folhaResult.ano}-${String(folhaResult.mes).padStart(2, '0')}-01`;
        const lastDayOfMonth = new Date(folhaResult.ano, folhaResult.mes, 0);
        const toDate = `${lastDayOfMonth.getFullYear()}-${String(lastDayOfMonth.getMonth() + 1).padStart(2, '0')}-${String(lastDayOfMonth.getDate()).padStart(2, '0')}`;

        const filters: { skip: number; take: number; fromDate: string; toDate: string; defensoriaId?: number; setorId?: number } = {
          skip: 0,
          take: 10000,
          fromDate,
          toDate,
        };
        if (idDefensoria != null && idDefensoria > 0) {
          filters.defensoriaId = idDefensoria;
        } else if (idSetor != null && idSetor > 0) {
          filters.setorId = idSetor;
        }

        const feriadosResult = await readHoliday(filters);

        // API retorna [array, total]; garantir uso seguro do primeiro elemento
        const lista = Array.isArray(feriadosResult) && Array.isArray(feriadosResult[0]) ? feriadosResult[0] : [];
        const firstDayDate = new Date(fromDate);
        const lastDayDate = new Date(toDate);
        const feriadosDoMes = lista.filter((f) => {
          const inicio = new Date(f.inicio);
          const fim = f.fim ? new Date(f.fim) : inicio;
          return inicio <= lastDayDate && fim >= firstDayDate;
        });

        setFeriados(feriadosDoMes);
        setMesSelecionado(`${folhaResult.ano}-${String(folhaResult.mes).padStart(2, '0')}`);
      } catch (error) {
        toast.error(String(error));
      } finally {
        setLoaded(true);
      }
    }

    fetchData();
  }, [folhaId]);

  useEffect(() => {
    setTextoBotaoA('');
    setTextoBotaoB('');
    if (folha) {
      switch (folha?.status) {
        case AttendanceSheetStatusEnum.CONCLUIDA:
          setTextoBotaoA('');
          setTextoBotaoB('');
          break;
        case AttendanceSheetStatusEnum.EM_PREENCHIMENTO:
        case AttendanceSheetStatusEnum.EM_CORRECAO:

          // Se é o estagiário
          if (context.state.cpf && folha.estagiario?.cpf && context.state.cpf == folha.estagiario.cpf) {
            setTextoBotaoA('Enviar para Assinatura');
          }
          // Se esta logado e tem permissões de criar folhas (algo elevado).
          else if (permissoesElevadas) {
            setTextoBotaoA('Enviar para Assinatura.');
          }
          setTextoBotaoB('');

          break;
        case AttendanceSheetStatusEnum.AGUARDANDO_ASSINATURA:

          if (context.state.cpf && folha.responsavel.cpf && context.state.cpf == folha.responsavel.cpf) {
            setTextoBotaoA('Assinar e Enviar para a Subdefensoria');
            setTextoBotaoB('Pedir Correção');
          } else if (permissoesElevadas) {
            setTextoBotaoA('Assinar e Enviar para a Subdefensoria.');
            setTextoBotaoB('Pedir Correção.');
          }
          break;
        case AttendanceSheetStatusEnum.AGUARDANDO_REVISAO:
          if (context.state.username) {
            setTextoBotaoA('Aceitar e Finalizar');
            setTextoBotaoB('Pedir Correção');
          }
          break;
      }
    }
  }, [folha?.status]);

  useEffect(() => {
    if (folha) {
      switch (folha?.status) {
        case AttendanceSheetStatusEnum.CONCLUIDA:
          setTituloDaCaixaDeTexto('');
          setCorpoDaCaixaDeTexto('');
          settituloBotaoPrincipal('');
          break;
        case AttendanceSheetStatusEnum.EM_PREENCHIMENTO:
        case AttendanceSheetStatusEnum.EM_CORRECAO:
          setTituloDaCaixaDeTexto('Enviar para Assinatura');
          setCorpoDaCaixaDeTexto(
            'Deseja realmente enviar esta folha de frequência para assinatura?',
          );
          settituloBotaoPrincipal('Enviar para Assinatura');
          break;
        case AttendanceSheetStatusEnum.AGUARDANDO_ASSINATURA:
          setTituloDaCaixaDeTexto(
            acaoDeConfirmar
              ? 'Aprovar a folha do estagiário'
              : 'Rejeitar a folha do estagiário',
          );
          setCorpoDaCaixaDeTexto(
            acaoDeConfirmar
              ? 'Deseja aceitar e assinar esta folha de frequência?'
              : 'Deseja rejeitar esta folha de frequência?',
          );
          settituloBotaoPrincipal(acaoDeConfirmar ? 'Aprovar' : 'Rejeitar');
          break;
        case AttendanceSheetStatusEnum.AGUARDANDO_REVISAO:
          setTituloDaCaixaDeTexto(
            acaoDeConfirmar
              ? 'Aprovar a folha do estagiário'
              : 'Rejeitar a folha do estagiário',
          );
          setCorpoDaCaixaDeTexto(
            acaoDeConfirmar
              ? 'Deseja aceitar e devolver esta folha de frequência?'
              : 'Deseja rejeitar esta folha de frequência?',
          );
          settituloBotaoPrincipal(acaoDeConfirmar ? 'Aprovar' : 'Rejeitar');
          break;
      }
    }
  }, [folha, acaoDeConfirmar]);

  const updateCalendarDay = async (_modifiedDay: AttendanceSheetDayDto) => {
    if (!folha) return;
    try {
      const folhaAtualizada = await readByIdAttendanceSheet(folha.id);
      setFolha(folhaAtualizada);
    } catch (error) {
      toast.error(String(error));
    }
  };

  async function handleSendToSignature(motivo?: string) {
    if (!folha || !folhaId)
      return;

    setExecuting(true)
    await sendToSignatureAttendanceSheet(folhaId, acaoDeConfirmar, motivo)
      .then(async (res) => {
        toast.success(res);

        // Recarrega os dados da folha para manter os dias
        const folhaAtualizada = await readByIdAttendanceSheet(folhaId);
        setFolha(folhaAtualizada);
      })
      .catch((error) => {
        toast.error(String(error));
      })
      .finally(() => {
        setExecuting(false);
        setShowConfirmModal(false);
      });
  }

  const calcularCargaHorariaMaxima = (lotacao: any): number => {
    if (!lotacao || !lotacao.entrada || !lotacao.saida) {
      return 300;
    }

    const [entradaH, entradaM] = lotacao.entrada.split(':').map(Number);
    const [saidaH, saidaM] = lotacao.saida.split(':').map(Number);

    const entradaMin = entradaH * 60 + entradaM;
    const saidaMin = saidaH * 60 + saidaM;

    return saidaMin - entradaMin;
  };

  function getNomeMes() {
    const timezone = 'America/Sao_Paulo';
    const date = new Date(`${mesSelecionado}-01T00:00:00`);
    const r = new Intl.DateTimeFormat('pt-BR', { timeZone: timezone, month: 'long', year: 'numeric', }).format(date)
    return r.charAt(0).toUpperCase() + r.slice(1);
  }

  function obterUltimaJustificativaRejeicao(folha: AttendanceSheetResponseDto): string {
    const assinaturasComJustificativa = folha?.assinaturas
      ?.filter((a) => a.justificativa)
      ?.sort((a, b) => new Date(b.criadoEm).getTime() - new Date(a.criadoEm).getTime());
    return assinaturasComJustificativa?.[0]?.justificativa ?? 'Não informado';
  }

  if (!loaded)
    return <Loading />;

  return (
    <div className="container container-frequencia" >
      <ToastContainer position="top-left" pauseOnFocusLoss={false} />

      {folha && (
        <div className="mb-4">
          <div className="d-flex align-items-center justify-content-between">
            <h4 style={{ fontWeight: 'bold' }}>{folha.estagiario?.nome}</h4>
            <div className="btn-group">

              <button className="btn btn-outline-secondary"
                onClick={() => navigate(-1)}
                title="Folhas de frequência" >
                Voltar
              </button>

              <span className='form-control btn-sm'>{getNomeMes()}</span>

              <Link className="btn btn-outline-secondary" to={Links.Folha_Frequencia_Index} title="Folhas do(a) Estagiário(a)" >
                Folhas
              </Link>
              <Link className="btn btn-outline-secondary" to={Links.Auth_Logout} title="Sair do sistema" >
                Sair
              </Link>
            </div>
          </div>

          <h5>{folha.estagio.local}</h5>

          <h5>Supervisor:  {folha.responsavel?.nome}</h5>

          <h5>
            Período de Estágio:{' '}
            {DataAmigavel(folha.estagio.data_inicio_estagio)} a{' '}
            {DataAmigavel(folha.estagio.data_fim_estagio)}
          </h5>
        </div>
      )}



      <div className="calendario">
        <div className="cabecalho-semana">
          {diasDaSemana.map((dia, index) => (
            <div key={index} className="dia-cabecalho">
              {dia}
            </div>
          ))}
        </div>
      </div>

      {folha && (
        <AttendanceCalendar
          folha={folha}
          updateCalendarDay={updateCalendarDay}
          horarioPadraoEntrada={folha.estagio.lotacao?.entrada ?? ''}
          horarioPadraoSaida={folha.estagio.lotacao?.saida ?? ''}
          isWeekendWorker={folha.estagio.fim_semana}
          cargaHorariaMaxima={calcularCargaHorariaMaxima(folha.estagio.lotacao)}
        />
      )}

      <div className="row mt-4">
        <div className="col-md-3">
          {TabelaResumo(folha)}
        </div>

        <div className='col-md-5'>
          <div className="d-flex justify-content-center">
            <span className="alert alert-warning text-start py-1 px-2" style={{ fontSize: 13 }} >
              {feriados.length === 0 ? (<>(Sem bloqueios esse mês)</>)
                : (
                  feriados.map((a, index) => (
                    <span key={'feriado-' + index}>
                      ({new Date(a.inicio).toLocaleDateString(LOCALIZACAO_SISTEMA, { month: 'numeric', day: 'numeric' })}) {a.nome}
                      <br className='pt-5' />
                    </span>
                  ))
                )}
            </span>
          </div>
        </div>

        <div className="col-md-4 d-flex flex-column align-items-end justify-content-start">
          <div className="d-flex gap-2">
            {textoBtnB && (
              <button className="btn btn-outline-danger" disabled={isExecuting} onClick={() => {
                setShowConfirmModal(true);
                setAcaoDeConfirmar(false);
              }}
              >
                {textoBtnB}
              </button>
            )}

            {textoBtnA && (
              <button className="btn btn-outline-success" disabled={isExecuting} onClick={() => {
                setShowConfirmModal(true);
                setAcaoDeConfirmar(true);
              }}
              >
                {textoBtnA}
              </button>
            )}
          </div>

          <div>
            <div className="mt-4">
              {
                <AttendanceSheetStatusIconByStatus
                  status={AttendanceSheetStatusEnum.EM_PREENCHIMENTO}
                  folhaStatus={folha?.status}
                />
              }
              {
                folha?.status === AttendanceSheetStatusEnum.EM_CORRECAO ? (
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => setShowModalJustificativa(true)}
                    onKeyDown={(e) => e.key === 'Enter' && setShowModalJustificativa(true)}
                    style={{ cursor: 'pointer' }}
                    title="Em correção. Clique para ver a justificativa."
                  >
                    <AttendanceSheetStatusIconByStatus
                      status={AttendanceSheetStatusEnum.EM_CORRECAO}
                      folhaStatus={folha?.status}
                    />
                  </span>
                ) : (
                  <AttendanceSheetStatusIconByStatus
                    status={AttendanceSheetStatusEnum.EM_CORRECAO}
                    folhaStatus={folha?.status}
                  />
                )
              }
              {
                <AttendanceSheetStatusIconByStatus
                  status={AttendanceSheetStatusEnum.AGUARDANDO_ASSINATURA}
                  folhaStatus={folha?.status}
                />
              }
              {
                <AttendanceSheetStatusIconByStatus
                  status={AttendanceSheetStatusEnum.AGUARDANDO_REVISAO}
                  folhaStatus={folha?.status}
                />
              }
              {
                <AttendanceSheetStatusIconByStatus
                  status={AttendanceSheetStatusEnum.CONCLUIDA}
                  folhaStatus={folha?.status}
                />
              }
              {folha && folha.status === AttendanceSheetStatusEnum.CONCLUIDA &&
                <Button
                  className="btn btn-sm btn-link link-secondary"
                  onClick={() => { printAttendanceSheet(folha.id) }}
                  title="Gerar um PDF da folha.">
                  <FaRegFilePdf size={22} color="#ff4444" />
                </Button>
              }
            </div>
            <div className="mt-2">
              <strong>{attendanceSheetStatusEnumInFull(folha?.status)}</strong>
            </div>
          </div>
        </div>
      </div>

      <footer
        className="text-center"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          background: '#f8f9fa',
          padding: '8px 0',
          borderTop: '1px solid #dee2e6',
          zIndex: 100,
        }}
      >
        <span style={{ fontSize: 16 }} onClick={() => { setShowModalHistorico(true) }}>
          Este acesso é pessoal e intransferível. Todas as ações são registradas
          com data, hora e IP.
        </span>
      </footer>

      <ModalConfirmarAcao
        show={showConfirmModal}
        executing={isExecuting}
        tituloBotaoPrincipal={tituloBotaoPrincipal}
        tituloDaCaixaDeTexto={tituloDaCaixaDeTexto}
        corpoDaCaixaDeTexto={corpoDaCaixaDeTexto}
        handleAcaoPrincipal={handleSendToSignature}
        handleHide={() => {
          setShowConfirmModal(false);
        }}
      />

      {folha &&
        <ModalHistorico
          folha={folha}
          show={showModalHistorico}
          handleHide={() => { setShowModalHistorico(false) }}
        />
      }

      <Modal
        show={showModalJustificativa}
        onHide={() => setShowModalJustificativa(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Justificativa da correção</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            {folha ? obterUltimaJustificativaRejeicao(folha) : 'Não informado'}
          </p>
        </Modal.Body>
      </Modal>
    </div >
  );
}

function TabelaResumo(folha: AttendanceSheetResponseDto | undefined) {
  return <table className="table table-bordered w-auto">
    <tbody>
      <tr>
        <th>Total de dias úteis</th>
        <td>{folha?.dias.filter((a) => a.util).length}</td>
      </tr>
      <tr>
        <th>Com presença marcada</th>
        <td>
          {folha?.dias.filter((a) => a.status === AttendanceSheetDayEnum.PRESENTE).length}
        </td>
      </tr>
      <tr>
        <th>Com falta</th>
        <td>
          {folha?.dias.filter((a) => a.status === AttendanceSheetDayEnum.FALTA_JUSTIFICADA || a.status === AttendanceSheetDayEnum.FALTA_NAO_JUSTIFICADA).length}
        </td>
      </tr>
      <tr>
        <th>Com observação</th>
        <td>
          {folha?.dias.filter((a) => a.justificativa).length}
        </td>
      </tr>
    </tbody>
  </table>
}

